import React from "react";
import { useApp } from "../../../contexts";
import { useState } from "react";
import ItemSubscriptionV2 from "../../../components/ItemSubscription/ItemSubscriptionV2";
import ItemSubscriptionMarketV2 from "../../../components/ItemSubscription/ItemSubscriptionMarketV2";
import ItemBonusV2 from "../../../components/ItemSubscription/ItemBonusV2";
import ItemBonusCheercast from "../../../components/ItemSubscription/ItemBonusCheercast";
import { filterObjectsByObjectCondition, sortByField } from '../../../utils/helper'
import { paginationRender, PaginationView } from "../../../components/Table";
import { useMemo } from "react";
import { SORT_SUB_MAPPING_KEY, SUZU_PLUS_OPTION_MAPPING } from "../../../constants";
import { useWindowSize } from "../../../hook/useWindowSize";
import ItemSubPrime from "../../../components/ItemSubscription/ItemSubPrime";
export const TabSubOption = {
  base: "suzu_base",
  plus: "suzu_plus",
  ai: "cheercast",
};


export const TabSubscriptionByType = (props) => {
  const { T, user } = useApp();
  const size = useWindowSize();
  const isMobile = size.width <= 1024 ? true : false;
  const pageSize = isMobile ? 24 : 25;
  const [subLink, setSubLink] = useState(`${user.store_shopify}?lang=${user.language}` || "");
  const {subType, filterData, handleFilterData} = props;
  const dataTab = useMemo(() => {
    return (props?.dataTab || []).map(item => {
      return {
        ...item,
        filterStatus: subType === 2 ? item?.sub?.status : item.status,
        price: subType === 2 ? item?.sub?.price_in_usd : +item.price,
        createTime: subType === 2 ? item?.sub?.start_date : item.created_at,
        filterId: subType === 2 ? item?.dog?.id : null,
        filterOptions:
          subType === 2
            ? item?.sub?.product_sku
            : subType === 3
            ? (item?.product_sku?.indexOf("CELEBRITY") !== -1 ? 'special': 'starter')
            : item?.product_sku,
      };
    })
  }, [props.dataTab]);

  const dataFilterCondition = useMemo(() => {
    let options = filterData?.options?.map((i) => i);
    if (subType === 2) {
      options = []
      filterData?.options?.map((i) => {
        options = options.concat(SUZU_PLUS_OPTION_MAPPING[i]);
      })
    }
    return {
      filterStatus:
        filterData?.statuss?.length === 0 || filterData?.statuss?.includes("")
          ? []
          : filterData?.statuss?.map((i) => +i),
      filterOptions: options,
      filterId: subType === 2 && filterData?.id ? [filterData?.id] : null,
    };
  },[filterData, subType])

  const dataSortCondition = useMemo(() => {
    const mapping = SORT_SUB_MAPPING_KEY[filterData.sort]
    if (!mapping) return SORT_SUB_MAPPING_KEY.priceDesc
    return mapping
  }, [filterData.sort])

  const dataFinals = useMemo(() => {
    const dataFilter = filterObjectsByObjectCondition(dataTab, dataFilterCondition);
    const dataSort = sortByField(dataFilter, dataSortCondition.column, dataSortCondition.direction);
    return dataSort || []
  },[dataTab, dataFilterCondition, dataSortCondition])
  
  const hanlePage = (page) => {
    handleFilterData({
      page: page
    })
  }
  
  return (
    <div className="flex flex-col gap-[20px] lg:gap-[30px] mt-[10px]">
      <div className="flex justify-between items-start gap-[40px]">
        <div className="asset-block w-full">
          <div
            className={`grid gap-[20px] grid-cols-1 xs:grid-cols-2 xs:gap-[15px] xl:grid-cols-5 lg:grid-cols-4 lg:gap-[20px] xl:gap-[20px]`}
          >
            {dataFinals.slice((filterData?.page - 1) * pageSize, filterData.page * pageSize).map((item, index) => {
              if (subType === 1) {
                return item?.inMarket ? (
                  <ItemSubscriptionMarketV2
                    key={index}
                    itemData={item}
                    handleReload={props?.loadData}
                    subLink={subLink}
                  />
                ) : (
                  <ItemSubscriptionV2
                    key={index}
                    itemData={item}
                    handleReload={props?.loadData}
                    subLink={subLink}
                  />
                );
              }
              if (subType === 2) {
                return (
                  <ItemBonusV2
                    key={index}
                    itemData={item}
                    handleReload={props?.loadData}
                    subLink={subLink}
                  />
                );
              }
              if (subType === 3) {
                return (
                  <ItemBonusCheercast
                    key={index}
                    itemData={item}
                    handleReload={props?.loadData}
                    subLink={subLink}
                  />
                );
              }
              if (subType === 4) {
                return (
                  <ItemSubPrime
                    key={index}
                    itemData={item}
                    handleReload={props?.loadData}
                    subLink={subLink}
                  />
                );
              }
            })}
          </div>
          {dataFinals?.length === 0 && (
            <>
              <div className="text-[#818181] text-sm flex-wrap lg:text-base flex justify-center items-center">
                <div className="w-full flex items-center lg:mt-[80px] mb-[16px] justify-center">
                  <img
                    className="w-[100px] lg:w-[160px]"
                    src={"/assets/images/empty-table.png"}
                    alt=""
                  />
                </div>
                <div className="w-full flex justify-center mb-[15px]">
                  {T("You haven't got anything yet.")}
                </div>
                <a
                  href={`${subLink}`}
                  target="_blank"
                  rel="noreferrer"
                  className="bg-black leading-[45px] !text-white rounded-[15px] px-[20px] h-[45px] button-boxshadow"
                >
                  {T("Go to Mall")}
                </a>
              </div>
            </>
          )}
          {dataFinals.length / 25 > 1 ? (
            <PaginationView
              current={filterData?.page || 1}
              pageSize={pageSize}
              onChange={(p, ps) => {
                hanlePage(p);
              }}
              total={dataFinals.length}
              itemRender={paginationRender}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};
